import { Theme } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const Styled = styled.div`
  .loading-message {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    .ui.loader {
      margin-right: 5px;
    }
  }
  &.playlist {
    background: ${Theme.color.nearWhite};
    .content-header {
      padding: 24px 24px 0 24px;
      justify-content: space-between;

      h3 {
        margin: 0;
        line-height: 36px;
      }

      .search-filter-container {
        width: 100%;
        display: flex;
        gap: 8px;
        align-items: center;

        .search {
          width: 100%;
        }

        .clear-all-tags-button {
          border: none;
          box-shadow: none;
          gap: var(--spacing-xxs);
          padding-left: 8px;
          padding-right: 12px;

          &:disabled {
            background: none;

            &:hover {
              background: none;
            }
          }

          @media screen and (max-width: ${Theme.break.mediumAlt}) {
            display: none;
          }
        }
      }
    }
    .container {
      &.has-selected-tags {
        height: calc(100% - 100px) !important;
      }
      .media-item-header {
        .media-core {
          h3 {
            padding: var(--spacing-sm, 8px) var(--spacing-xl, 24px);
            font-size: 16px;
            font-weight: 600;
            color: var(--color-gray-950, #19191b);
          }
        }
      }
    }
  }
`;
